var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse2, _path19, _path20, _path21, _path22, _path23, _ellipse3, _path24, _path25, _ellipse4, _ellipse5, _path26, _ellipse6, _ellipse7, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBalanceScales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2cbff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(0 1 -1 0 79.271 89.271)",
    gradientUnits: "userSpaceOnUse",
    x1: 52.25,
    x2: 104.07,
    xlinkHref: "#lg1",
    y1: -175.729,
    y2: -175.729
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.622,
    x2: 245.378,
    xlinkHref: "#lg2",
    y1: 154.061,
    y2: 104.926
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3ced",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3c3de4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541cc",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f43bb"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.599,
    x2: 252.785,
    xlinkHref: "#lg3",
    y1: 176.528,
    y2: 117.669
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.003,
    x2: 289.918,
    xlinkHref: "#lg1",
    y1: 291.271,
    y2: 291.271
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.297,
    x2: 154.64,
    xlinkHref: "#lg2",
    y1: 292.196,
    y2: 264.199
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.283,
    x2: 230.817,
    xlinkHref: "#lg3",
    y1: 162.983,
    y2: 98.439
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 107.804,
    y2: 127.853
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 125.274,
    y2: 145.323
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.506,
    x2: 296.384,
    xlinkHref: "#lg1",
    y1: 45.283,
    y2: 98.161
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.327,
    x2: 241.639,
    xlinkHref: "#lg3",
    y1: 56.777,
    y2: 56.777
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.706,
    x2: 312.582,
    y1: 36.483,
    y2: 114.359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3ced"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.278,
    x2: 218.133,
    xlinkHref: "#lg5",
    y1: 73.133,
    y2: -8.218
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.188,
    x2: 229.688,
    xlinkHref: "#lg5",
    y1: 72.615,
    y2: 58.849
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 443.968,
    y2: 461.923
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 454.485,
    y2: 481.516
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 474.221,
    y2: 517.483
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.006,
    x2: 133.827,
    xlinkHref: "#lg6",
    y1: 300.941,
    y2: 414.854
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.827,
    x2: -17.73,
    xlinkHref: "#lg7",
    y1: 334.888,
    y2: 302.089
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b43759"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.089,
    x2: 188.557,
    xlinkHref: "#lg8",
    y1: 339.718,
    y2: 432.336
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.73,
    x2: 96.73,
    xlinkHref: "#lg6",
    y1: 346.774,
    y2: 290.238
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(.869 .494 -.494 .869 132.631 -100.146)",
    gradientUnits: "userSpaceOnUse",
    x1: 96.923,
    x2: 110.662,
    xlinkHref: "#lg9",
    y1: 340.437,
    y2: 340.437
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-.869 .494 .494 .869 293.292 -100.146)",
    gradientUnits: "userSpaceOnUse",
    x1: 299.029,
    x2: 312.767,
    xlinkHref: "#lg9",
    y1: 225.575,
    y2: 225.575
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.547,
    x2: 450.367,
    xlinkHref: "#lg6",
    y1: 300.941,
    y2: 414.854
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.367,
    x2: 298.811,
    xlinkHref: "#lg7",
    y1: 334.888,
    y2: 302.089
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.629,
    x2: 505.098,
    xlinkHref: "#lg8",
    y1: 339.718,
    y2: 432.336
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.27,
    x2: 413.27,
    xlinkHref: "#lg6",
    y1: 346.774,
    y2: 290.238
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(.869 .494 -.494 .869 132.631 -100.146)",
    gradientUnits: "userSpaceOnUse",
    x1: 372.125,
    x2: 385.864,
    xlinkHref: "#lg9",
    y1: 184.033,
    y2: 184.033
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-.869 .494 .494 .869 293.292 -100.146)",
    gradientUnits: "userSpaceOnUse",
    x1: 23.826,
    x2: 37.565,
    xlinkHref: "#lg9",
    y1: 381.979,
    y2: 381.979
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.591,
    x2: 121.688,
    xlinkHref: "#lg6",
    y1: 149.224,
    y2: 184.321
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.429,
    x2: 74.906,
    xlinkHref: "#lg7",
    y1: 162.063,
    y2: 137.54
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.668,
    x2: 134.897,
    xlinkHref: "#lg8",
    y1: 169.742,
    y2: 100.501
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.131,
    x2: 438.228,
    xlinkHref: "#lg6",
    y1: 149.224,
    y2: 184.321
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.97,
    x2: 391.447,
    xlinkHref: "#lg7",
    y1: 162.063,
    y2: 137.54
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.209,
    x2: 451.438,
    xlinkHref: "#lg8",
    y1: 169.742,
    y2: 100.501
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.854 158.487c0-10.146 8.225-18.371 18.371-18.371h307.549c10.146 0 18.371 8.225 18.371 18.371 0 10.146-8.225 18.371-18.371 18.371h-307.549c-10.146 0-18.371-8.225-18.371-18.371z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m101.259 147.692c-8.863 0-16.259 6.255-18.009 14.583 1.75 8.328 9.145 14.583 18.009 14.583h307.482c8.863 0 16.259-6.255 18.009-14.583-1.75-8.328-9.145-14.583-18.009-14.583z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m271.164 176.858h39.294l-36.809-36.742h-2.485z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m236.596 132.29h36.809v317.963h-36.809z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m247.939 132.29h25.465v317.963h-25.465z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m273.405 132.289h-36.809v7.583l36.809 36.742z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m269.085 123.555h-28.17c-4.824 0-8.735-3.911-8.735-8.735 0-4.824 3.911-8.735 8.735-8.735h28.17c4.824 0 8.735 3.911 8.735 8.735-.001 4.824-3.911 8.735-8.735 8.735z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m269.085 141.024h-28.17c-4.824 0-8.735-3.911-8.735-8.735 0-4.824 3.911-8.735 8.735-8.735h28.17c4.824 0 8.735 3.911 8.735 8.735-.001 4.824-3.911 8.735-8.735 8.735z",
    fill: "url(#SVGID_8_)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 56.777,
    fill: "url(#SVGID_9_)",
    rx: 56.881,
    ry: 56.777
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m311.881 56.777c0-31.357-25.467-56.777-56.881-56.777v113.554c31.414 0 56.881-25.42 56.881-56.777z",
    fill: "url(#SVGID_10_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m255 0c-31.415 0-56.881 25.42-56.881 56.777s25.466 56.777 56.881 56.777 56.881-25.42 56.881-56.777-25.467-56.777-56.881-56.777zm43.567 56.777c0 8.342-2.355 16.134-6.435 22.754l-26.566-26.517-3.095-3.089v-35.996c20.502 3.537 36.096 21.374 36.096 42.848zm-51.039 42.848c-7.387-1.274-14.135-4.406-19.748-8.894l19.748-19.711zm14.944-28.606 19.748 19.711c-5.613 4.489-12.361 7.62-19.748 8.894zm-14.944-57.09v35.996l-3.095 3.089-26.565 26.517c-4.08-6.62-6.435-14.412-6.435-22.754 0-21.474 15.594-39.311 36.095-42.848z",
    fill: "url(#SVGID_11_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m255 3.083c-29.708 0-53.792 24.04-53.792 53.694s24.084 53.694 53.792 53.694 53.792-24.04 53.792-53.694-24.084-53.694-53.792-53.694zm-7.472 96.542c-7.387-1.274-14.135-4.406-19.748-8.894l19.748-19.711zm0-49.7-3.095 3.089-26.565 26.517c-4.08-6.62-6.435-14.412-6.435-22.754 0-21.474 15.594-39.311 36.095-42.848zm14.944 49.7v-28.606l19.748 19.711c-5.613 4.489-12.362 7.621-19.748 8.895zm3.095-46.611-3.095-3.089v-35.996c20.501 3.537 36.095 21.374 36.095 42.848 0 8.342-2.355 16.134-6.435 22.754z",
    fill: "url(#SVGID_12_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m247.939 53.077-28.514 28.462 8.782 8.766 19.321-19.286z",
    fill: "url(#SVGID_13_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m285.065 461.41h-60.13v-11c0-6.249 5.066-11.315 11.315-11.315h37.5c6.249 0 11.315 5.066 11.315 11.315z",
    fill: "url(#SVGID_14_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m311.582 462.112c-2.301-4.732-6.445-7.627-10.917-7.627h-91.332c-4.472 0-8.616 2.895-10.917 7.627-4.895 10.067-13.711 16.227-23.225 16.227v22.811h159.615v-22.811c-9.512 0-18.329-6.16-23.224-16.227z",
    fill: "url(#SVGID_15_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m347.634 510h-185.269c-3.333 0-6.035-2.702-6.035-6.035v-3.341c0-13.307 10.788-24.095 24.095-24.095h149.147c13.307 0 24.095 10.788 24.095 24.095v3.341c.002 3.333-2.7 6.035-6.033 6.035z",
    fill: "url(#SVGID_16_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m193.46 324.731c0 35.71-43.307 64.658-96.73 64.658s-96.73-28.949-96.73-64.658 193.46-35.71 193.46 0z",
    fill: "url(#SVGID_17_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m100.001 389.348c51.907-1.154 93.459-29.64 93.459-64.617 0-17.452-46.208-26.373-93.459-26.767-47.25.394-93.459 9.315-93.459 26.767 0 34.977 41.552 63.463 93.459 64.617z",
    fill: "url(#SVGID_18_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m153.399 302.547c6.323 3.562 9.996 7.8 9.996 12.716 0 35.71-43.307 64.658-96.73 64.658-8.844 0-17.409-.798-25.548-2.284 15.732 7.403 34.912 11.752 55.613 11.752 53.422 0 96.73-28.948 96.73-64.658 0-10.458-16.596-17.852-40.061-22.184z",
    fill: "url(#SVGID_19_)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.73,
    cy: 321.872,
    fill: "url(#SVGID_20_)",
    rx: 90.187,
    ry: 17.897
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m9.263 326.835c-3.266-1.853-4.408-5.997-2.552-9.257l84.069-147.638c1.856-3.26 6.008-4.4 9.274-2.548 3.266 1.853 4.408 5.997 2.552 9.257l-84.07 147.638c-1.856 3.26-6.008 4.401-9.273 2.548z",
    fill: "url(#SVGID_21_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m184.197 326.835c3.266-1.853 4.408-5.997 2.552-9.257l-84.069-147.638c-1.856-3.26-6.008-4.4-9.274-2.548-3.266 1.853-4.408 5.997-2.552 9.257l84.07 147.638c1.855 3.26 6.007 4.401 9.273 2.548z",
    fill: "url(#SVGID_22_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m510 324.731c0 35.71-43.307 64.658-96.73 64.658s-96.73-28.948-96.73-64.658 193.46-35.71 193.46 0z",
    fill: "url(#SVGID_23_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m416.541 389.348c51.907-1.154 93.459-29.64 93.459-64.617 0-17.452-46.208-26.373-93.459-26.767-47.25.394-93.459 9.315-93.459 26.767.001 34.977 41.552 63.463 93.459 64.617z",
    fill: "url(#SVGID_24_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m469.939 302.547c6.323 3.562 9.996 7.8 9.996 12.716 0 35.71-43.307 64.658-96.73 64.658-8.844 0-17.409-.798-25.548-2.284 15.732 7.403 34.912 11.752 55.613 11.752 53.422 0 96.73-28.948 96.73-64.658 0-10.458-16.595-17.852-40.061-22.184z",
    fill: "url(#SVGID_25_)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.27,
    cy: 321.872,
    fill: "url(#SVGID_26_)",
    rx: 90.187,
    ry: 17.897
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m325.803 326.835c-3.266-1.853-4.408-5.997-2.552-9.257l84.07-147.638c1.856-3.26 6.008-4.4 9.274-2.548 3.266 1.853 4.408 5.997 2.552 9.257l-84.07 147.638c-1.856 3.26-6.008 4.401-9.274 2.548z",
    fill: "url(#SVGID_27_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m500.737 326.835c3.266-1.853 4.408-5.997 2.552-9.257l-84.069-147.638c-1.856-3.26-6.008-4.4-9.274-2.548-3.266 1.853-4.408 5.997-2.552 9.257l84.07 147.638c1.856 3.26 6.008 4.401 9.273 2.548z",
    fill: "url(#SVGID_28_)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.73,
    cy: 159.363,
    fill: "url(#SVGID_29_)",
    rx: 27.123,
    ry: 27.074
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.73,
    cy: 159.363,
    fill: "url(#SVGID_30_)",
    rx: 22.637,
    ry: 22.595
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m108.863 135.145c1.829 3.644 2.86 7.757 2.86 12.111 0 14.952-12.143 27.074-27.123 27.074-4.362 0-8.482-1.029-12.133-2.855 4.453 8.872 13.645 14.963 24.263 14.963 14.98 0 27.123-12.121 27.123-27.074 0-10.6-6.102-19.774-14.99-24.219z",
    fill: "url(#SVGID_31_)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.27,
    cy: 159.363,
    fill: "url(#SVGID_32_)",
    rx: 27.123,
    ry: 27.074
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.27,
    cy: 159.363,
    fill: "url(#SVGID_33_)",
    rx: 22.637,
    ry: 22.595
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m425.403 135.145c1.829 3.644 2.861 7.757 2.861 12.111 0 14.952-12.143 27.074-27.123 27.074-4.362 0-8.482-1.029-12.133-2.855 4.453 8.872 13.645 14.963 24.263 14.963 14.98 0 27.123-12.121 27.123-27.074-.001-10.6-6.103-19.774-14.991-24.219z",
    fill: "url(#SVGID_34_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBalanceScales);
export default __webpack_public_path__ + "static/media/icon-balance-scales.3b1f2b6d823ee4af9baf37bd9de38c7c.svg";
export { ForwardRef as ReactComponent };